import React from "react"
import RouteRenderer from "./routes/RouteRenderer"
import { Toaster } from 'react-hot-toast';
import { LoaderProvider } from "./context/LoaderContext"
import { AppContextProvider } from "./context/AppContext";
import { CustomLabelsProvider } from "./context/CustomLabelsContext";
import { SitesContextProvider } from "./context/SitesContext";
import { SitesListDropDownContextProvider } from "./context/SitesListDropDownContext";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { HelmetProvider } from "react-helmet-async";


const App = () => {

  const CustomFontTheme = createTheme({
    typography: {
      fontFamily: '"Lato", sans-serif !important',
      fontSize: 14,
    }
  });

  // Added Release notes
  return (
    <>
      <ThemeProvider theme={CustomFontTheme}>
        <Toaster />
        <LoaderProvider>
          <CustomLabelsProvider>
            <HelmetProvider>
              <AppContextProvider>
                <SitesContextProvider>
                  <SitesListDropDownContextProvider>
                    <RouteRenderer />
                  </SitesListDropDownContextProvider>
                </SitesContextProvider>
              </AppContextProvider>
            </HelmetProvider>
          </CustomLabelsProvider>
        </LoaderProvider>
      </ThemeProvider>
    </>
  )
}

export default App;
